import {ScenarioCoefficientsGrouping, ScenarioValuesGrouping} from "../../../../../generated-api-v3";


export function getAllocationTableData(
  allocationList?: ScenarioValuesGrouping | ScenarioCoefficientsGrouping | undefined,
  useBackendData?: boolean,
  options?: {
    priceMultiplier: number, fxMultiplier: number, yieldMultiplier: number, volatilityMultiplier: number
  }) {
  if(useBackendData){
    return getAllocationTableDataFromBackendData(allocationList);
  }
  return getAllocationTableDataFromCoefficients(allocationList, options);
}

export function getAllocationTableDataFromBackendData(
  allocationList?: ScenarioValuesGrouping | ScenarioCoefficientsGrouping | undefined,
  ) {
  
    return allocationList?.entries?.map((allocation:any) => {
      const name:string = allocation?.name;
      const priceImpact:number = allocation?.priceValue ?? 0;
      const fxImpact:number =  (allocation?.fxValue ?? 0);
      const yieldImpact:number =  (allocation?.yieldValue ?? 0);
      const volatilityImpact:number =  (allocation?.volatilityValue ?? 0);
      const exposure:number =  allocation?.totalExposureBase ?? 0;

      const value = allocation?.totalMarketValueBase

      const absolutePriceImpact = priceImpact + yieldImpact;
      const totalImpact = absolutePriceImpact + fxImpact + volatilityImpact;


      return {
        name,
        value,
        priceImpact: absolutePriceImpact,
        fxImpact,
        yieldImpact,
        totalImpact,
        volatilityImpact,
        exposure,
      }
    })
  }


export function getAllocationTableDataFromCoefficients(
  allocationList?: ScenarioValuesGrouping | ScenarioCoefficientsGrouping | undefined,
  options?: {
    priceMultiplier: number, fxMultiplier: number, yieldMultiplier: number, volatilityMultiplier: number
  }) {
  
  return allocationList?.entries?.map((allocation:any) => {
    const name:string = allocation?.name;
    const priceImpact:number = (options?.priceMultiplier ?? 0 ) * (allocation?.priceMultiplier ?? 0);
    const fxImpact:number =  (options?.fxMultiplier ?? 0 ) * (allocation?.fxMultiplier ?? 0);
    const yieldImpact:number =  (options?.yieldMultiplier ?? 0 ) * (allocation?.yieldMultiplier ?? 0);
    const volatilityImpact:number =  (options?.volatilityMultiplier ?? 0 ) * (allocation?.volatilityMultiplier ?? 0);
    const exposure:number = allocation?.instruments?.reduce((prev:number, curr: any) => {
      return prev + curr?.marketValueBase ?? 0
    }, 0) ;
    
    const value = allocation?.instruments?.reduce((prev:number, curr:any) => (prev ?? 0)  + (curr?.marketValueBase ?? 0) ,0)
    
    const absolutePriceImpact = priceImpact + yieldImpact;
    const totalImpact = absolutePriceImpact + fxImpact + volatilityImpact;
    
    return {
      name,
      value,
      priceImpact: absolutePriceImpact,
      fxImpact,
      yieldImpact,
      totalImpact,
      volatilityImpact,
      exposure,
    }
  })
}
